import React from 'react';
import { useTranslation } from 'react-i18next';

// listas de la persona (las mismas que usa la ficha del staff)
import PersonPhonesListComponent from '../../Persons/PersonPhones/PersonPhones.List.Component';
import PersonEmailsListComponent from '../../Persons/PersonEmails/PersonEmails.List.Component';
import PersonAddressesListComponent from '../../Persons/PersonAddresses/PersonAddresses.List.Component';
import PersonRelationshipsListComponent from '../../Persons/PersonRelationships/PersonRelationships.List.Component';
import { PersonContactCard } from '../../Persons/PersonContactList/PersonContactList.Component';

// guía
import { GuideSectionTitle } from '../../../theme/components/GuideSectionTitle';

import './ProviderContact.Styles.css';

export interface ProviderContactSectionProps {
  /** Id de la persona del proveedor (`provider.person.id`), no el id del proveedor. */
  PersonId: number;
  PersonType?: number;
}

/**
 * Ficha de contacto del proveedor: tarjeta compacta (teléfonos y correos lado a lado,
 * domicilios a lo ancho) y, debajo, las personas de contacto. Los datos viven en la persona
 * del proveedor (Persons.API), así que se reutilizan las mismas listas que la ficha del staff.
 */
export const ProviderContactSection = ({ PersonId, PersonType }: ProviderContactSectionProps) => {
  const [t] = useTranslation();

  return (
    <div className="pvc-root" data-testid="provider-contact">
      <GuideSectionTitle
        title={t('providerContact.title')}
        description={t('providerContact.description')}
      />
      <PersonContactCard>
        <PersonPhonesListComponent PersonId={PersonId} />
        <PersonEmailsListComponent PersonId={PersonId} />
        <PersonAddressesListComponent PersonId={PersonId} />
      </PersonContactCard>

      <section className="pvc-contacts" aria-labelledby="pvc-contacts-title">
        <GuideSectionTitle as="h4" id="pvc-contacts-title" title={t('providerContact.tabs.contacts')} className="pvc-contacts__title" />
        <PersonRelationshipsListComponent PersonId={PersonId} PersonType={PersonType} />
      </section>
    </div>
  );
};

export default ProviderContactSection;
